import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { CommonComponent } from './components/shared/common/common.component';
import { DataManagementComponent } from './components/data-management/data-management.component';
import { ReportManagementComponent } from './components/report-management/report-management.component';
import { AuthGuardService } from './shared/onelogin/auth-guard.service';
import { NoauthroizedComponent } from './noauthroized/noauthroized.component';
import { LogoutComponent } from './components/logout/logout.component';
import { LoginComponent } from './components/login/login.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'non-authorized', component: NoauthroizedComponent },
  {
    path: '',
    component: CommonComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'menu_datamanagement',
        component: DataManagementComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'menu_report',
        component: ReportManagementComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'menu_user',
        component: HomeComponent,
        canActivate: [AuthGuardService]
      },
      { path: '**', pathMatch: 'full', redirectTo: 'home' },
    ]
  },
  { path: '**', redirectTo: 'login' }
];
